import CloseIcon from '@mui/icons-material/Close';
import { Alert, IconButton, useTheme } from '@mui/material';
import React, { ReactNode } from 'react';

export enum ThemeMode {
  LIGHT = 'light',
  DARK = 'dark',
}

interface CustomAlertProps {
  isCritical?: boolean;
  children: ReactNode;
  onClose?: () => void;
  closeButtonAriaLabel?: string;
}

const Banner: React.FC<CustomAlertProps> = ({
  isCritical,
  children,
  onClose,
  closeButtonAriaLabel = 'Dismiss banner',
}) => {
  const theme = useTheme();

  return (
    <Alert
      color={isCritical ? 'error' : 'warning'}
      icon={false}
      action={
        onClose && (
          <IconButton
            aria-label={closeButtonAriaLabel}
            color="inherit"
            size="small"
            onClick={onClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )
      }
      sx={{
        width: '100%',
        justifyContent: 'center',
        '& .MuiAlert-message': {
          color: theme?.palette?.mode === ThemeMode.DARK ? 'white !important' : 'black !important',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        },
        mb: 2,
      }}
    >
      {children}
    </Alert>
  );
};

export default Banner;
